function isGWAT() {
  return process.env.REACT_APP_TENANT.toLowerCase().includes("gwat");
}

module.exports = {
  isGWAT,
};
